<app-programtitle title="Highest Mark"></app-programtitle>
<p> Write a program to calculate the highest mark in a given set of marks</p>

<app-editor code="{{program}}"> </app-editor>